import {DateTime} from "luxon";
import {Order, OrderState} from "../types";
import {Badge} from "@variocube/cube-ui";
import * as React from "react";
import {useLocalization} from "../../i18n";

export function OrderDisplay({order}: { order: Order }) {
    return (
        <div>
            <div><strong>{getOrderNumberDisplay(order)}</strong></div>
            <div>{DateTime.fromISO(order.orderDate).toLocaleString()}</div>
        </div>
    );
}

export function getOrderNumberDisplay(order: Order) {
    return [order.orderNumber, order.foreignId]
        .filter(part => !!part)
        .join(": ");
}

/**
 * Adjusts an orderState based on whether there is currently an occupancy for that order.
 * This allows to reflect local changes when the data has not been updated by the backend yet.
 * @param orderState
 * @param hasOccupancy
 */
export function adjustOrderState(orderState: OrderState, hasOccupancy: boolean) {
    switch (orderState) {
        case OrderState.Ordered:
            if (hasOccupancy) {
                return OrderState.WaitingForPickupByShop;
            }
            break;

        case OrderState.WaitingForPickupByShop:
            if (!hasOccupancy) {
                return OrderState.Processing;
            }
            break;

        case OrderState.ReadyForDelivery:
            if (hasOccupancy) {
                return OrderState.WaitingForPickupByCustomer;
            }
            break;

        case OrderState.WaitingForPickupByCustomer:
            if (!hasOccupancy) {
                return OrderState.Complete;
            }
            break;
    }
    return orderState;
}


export function OrderStatus({status}: { status: OrderState }) {
    const {t} = useLocalization();
    return <Badge>{t("OrderState:" + status as any)}</Badge>;
}